import { render } from "./CalendarManagementDetailForm.vue?vue&type=template&id=5e622144&scoped=true&ts=true"
import script from "./CalendarManagementDetailForm.vue?vue&type=script&lang=ts"
export * from "./CalendarManagementDetailForm.vue?vue&type=script&lang=ts"

import "./CalendarManagementDetailForm.vue?vue&type=style&index=0&id=5e622144&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e622144"]])

export default __exports__